import {makeLoader} from './makeLoader';

export const countryCodes = makeLoader('/countryCodes/get.json', 'countryCodes');
